export default "__VITE_ASSET__Beb8tNMk__"